export default {
  // 放映前多少分钟不可以修改出票
  unable_edit_pushticket_time: 300000,

  postStatus: {
    draft: '草稿',
    published: '发布',
    recycled: "垃圾"
  },
  postType: {
    AR: 'AR资讯',
    HEALTH: '健康资讯',
  },
  sex: {
    male: '男',
    female: '女',
    unknown: '未知'
  },
  tiketOrderStatus: {
    None: { type: 'info', name: '未付款' },
    Payed: { type: 'warning', name: '待充值' },
    Delivered: { type: 'success', name: '已充值' },
    Completed: { type: 'success', name: '已完成' },
    Refunded: { type: 'danger', name: '已退单' },
    Cancel: { type: 'danger', name: '已取消' },
    Fail: { type: 'danger', name: '失败' },
  },

  providerArr: [
    { name: '星星话费', value: 'XingXing' },
    { name: '鲸360', value: 'Jing360' },
    { name: '微点话费', value: 'WeiDian' },
    { name: '橘子优充', value: 'OrangeRecharge' },
    { name: '券码无忧', value: 'Quanma51' },
    { name: '微客云', value: 'Wikeyun' },
    { name: '手动出单', value: 'Handler' },
  ],

  goodsTypes: [
    { name: "话费充值", value: "TelephoneCharge" },
    { name: "油卡充值", value: "OilCardCharge" },
    { name: "本地生活", value: "LocalCater" },
    { name: "电商产品", value: "Eshop" },
  ],


  socketBackValue: {
    NewMovieTicketOrder: { name: '新订单提醒' },
    NewTicketerOrder: { name: '接单成功提醒' },
    TicketerOrderTimeout: { name: '出票超时提醒' },
    MovieTicketOrderCount: { name: '接单大厅数量' },
    TicketerOrderCount: { name: '我的订单数量' },
    BidingOrderCount: { name: '竞价中订单数量' }
  },

}